import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, Users, FileText, ExternalLink, LayoutDashboard, Store, DollarSign } from 'lucide-react';
import { useAdmin } from './AdminAuth';
import StatsPanel from './StatsPanel';
import SignupsPanel from './SignupsPanel';
import ContentPanel from './ContentPanel';
import MarketplacePanel from './MarketplacePanel';
import RevenuePanel from './RevenuePanel';

const AdminDashboard = () => {
  const { logout } = useAdmin();
  const navigate = useNavigate();
  const [tab, setTab] = useState('overview');

  const doLogout = () => { logout(); navigate('/admin/login'); };

  const tabs = [
    { key: 'overview', label: 'Overview', icon: LayoutDashboard },
    { key: 'revenue', label: 'Revenue', icon: DollarSign },
    { key: 'marketplace', label: 'Marketplace', icon: Store },
    { key: 'signups', label: 'Sign-ups', icon: Users },
    { key: 'content', label: 'Content', icon: FileText },
  ];

  return (
    <div className="min-h-screen bg-[#f6f6f2]">
      <header className="bg-white border-b border-[#0f1712]/8 sticky top-0 z-20">
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-8">
            <span className="brand text-2xl text-[#0f1712]">flix<span className="text-[#0e9f6e]">.</span></span>
            <span className="hidden sm:inline text-xs font-semibold uppercase tracking-widest text-[#0f1712]/40">Admin</span>
          </div>
          <div className="flex items-center gap-2">
            <a href="/" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-sm font-semibold text-[#0f1712]/70 hover:text-[#0e9f6e] px-3 py-2 transition-colors">
              <ExternalLink size={15} /> View site
            </a>
            <button onClick={doLogout} className="inline-flex items-center gap-2 text-sm font-semibold text-[#0f1712] rounded-xl border border-[#0f1712]/15 px-4 py-2 hover:border-red-400 hover:text-red-500 transition-colors">
              <LogOut size={15} /> Log out
            </button>
          </div>
        </div>
      </header>

      <div className="max-w-6xl mx-auto px-6 pt-6">
        <div className="flex gap-2 mb-8">
          {tabs.map((t) => {
            const Icon = t.icon;
            const active = tab === t.key;
            return (
              <button key={t.key} onClick={() => setTab(t.key)}
                className={`inline-flex items-center gap-2 rounded-xl px-5 py-2.5 text-sm font-semibold transition-colors ${active ? 'bg-[#0f1712] text-white' : 'bg-white text-[#0f1712]/70 border border-[#0f1712]/10 hover:border-[#0e9f6e]'}`}>
                <Icon size={16} /> {t.label}
              </button>
            );
          })}
        </div>

        <div className="pb-20">
          {tab === 'overview' && <StatsPanel />}
          {tab === 'revenue' && <RevenuePanel />}
          {tab === 'marketplace' && <MarketplacePanel />}
          {tab === 'signups' && <SignupsPanel />}
          {tab === 'content' && <ContentPanel />}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
